export const PAYLOAD_PACKAGE_LIST = [
  'payload',
  '@payloadcms/bundler-vite',
  '@payloadcms/bundler-webpack',
  '@payloadcms/db-mongodb',
  '@payloadcms/db-postgres',
  '@payloadcms/email-nodemailer',
  '@payloadcms/email-resend',
  '@payloadcms/graphql',
  '@payloadcms/live-preview-react',
  '@payloadcms/live-preview',
  '@payloadcms/next/utilities',
  '@payloadcms/plugin-cloud-storage',
  '@payloadcms/payload-cloud',
  '@payloadcms/plugin-form-builder',
  '@payloadcms/plugin-import-export',
  // '@payloadcms/plugin-multi-tenant',
  '@payloadcms/plugin-nested-docs',
  '@payloadcms/plugin-redirects',
  '@payloadcms/plugin-search',
  '@payloadcms/plugin-seo',
  '@payloadcms/plugin-stripe',
  '@payloadcms/plugin-zapier',
  '@payloadcms/richtext-lexical',
  '@payloadcms/richtext-slate',
  '@payloadcms/storage-azure',
  '@payloadcms/storage-gcs',
  '@payloadcms/storage-s3',
  '@payloadcms/storage-uploadthing',
  '@payloadcms/storage-vercel-blob',
  '@payloadcms/translations',
  '@payloadcms/ui/shared',
]
